export const SIMPLE_CARD_VARIANT = ['elevated', 'flat', 'radio', 'checkbox'];
export const SIMPLE_CARD_IMAGE_POSITION = ['top', 'left', 'right', 'bottom'];